import React from 'react';
import PropTypes from 'prop-types';

export default function SeatIcon({ scaleFactor = 1 }) {
  return (
   <svg
    width={32 * scaleFactor}
    height={32 * scaleFactor}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
   >
    {/* <rect width="32" height="32" fill="#EAEEF0"/>  */}
    <path
     d="M9 8C9 6.89543 9.89543 6 11 6H25C26.1046 6 27 6.89543 27 8V24C27 25.1046 26.1046 26 25 26H11C9.89543 26 9 25.1046 9 24V8Z"
     fill="#DCE2E6"
    />
     <path
      d="M5 10C5 8.89543 5.89543 8 7 8H9C10.1046 8 11 8.89543 11 10V22C11 23.1046 10.1046 24 9 24H7C5.89543 24 5 23.1046 5 22V10Z"
      fill="#DCE2E6"
     />
      <rect x="2" y="2" width="5" height="28" rx="2.5" fill="#DCE2E6" />
      <rect x="8" y="2" width="12" height="3" rx="1.5" fill="#DCE2E6" />
      <rect x="8" y="27" width="12" height="3" rx="1.5" fill="#DCE2E6" />
   </svg>
  );
}

SeatIcon.propTypes = {
 scaleFactor: PropTypes.number,
};
